import React from 'react';
import { connect } from 'react-redux';
import { showPreLoader } from 'actions/preLoaderActions';
import { bindActionCreators } from 'redux';
import { Header } from 'components/header/header';
import OKPDFViewer from '../../components/commons/OKPdfViewer/OKPdfViewer';
import { base64ToBlob, downloadAsFile } from '../../utilities/APIRequestHelper';
import './IneLoan.scss';
import Headline from 'components/headline';
import { RoadmapNavigation } from '../../components/steps/roadmapNavigation';
import { loanIne } from 'actions/aresActions';
import { PUBLICA_URL } from '../../constants';
import { printPdf } from '../../utilities/pdf';

import { formatText } from 'core/i18n';

class IneLoan extends React.Component {
    constructor(props) {
        super(props);
        this.state = { readDocument: false };
        this.onContinueAction = this.onContinueAction.bind(this);
    }

    onContinueAction = () => {
        const { loanIne, showPreLoader } = this.props;
        showPreLoader();
        loanIne();
    };

    render() {
        const { readDocument } = this.state;
        const { pdfFile } = this.props;

        return (
            <div className="prospects-content">
                <Header showContinueProcess={false} />
                <Headline icon="ine" className="title-container">
                    <h2>{formatText('stepsTitles-loanContracting_ares')}</h2>
                </Headline>
                <div className="pdf-viewer-container">
                    <OKPDFViewer
                        showScroll
                        displayScrollButton
                        viewerHeight={'405px'}
                        onDownload={() => {
                            downloadAsFile(
                                base64ToBlob(pdfFile),
                                'application/pdf',
                                `${formatText('loanContracting-uploadDocument')}.pdf`
                            );
                        }}
                        onPrint={() => printPdf(pdfFile)}
                        title={formatText('loanContracting-ineInfo_ares')}
                        pdfFile={pdfFile}
                        handleDocumentReaded={() => {
                            this.setState({ readDocument: true });
                        }}
                    />
                    <p>{formatText('loanContracting-legalCheck_ares')}</p>
                </div>
                <div className="footer">
                    <RoadmapNavigation
                        buttonContinueDisabled={!readDocument}
                        buttonPrevHidden={true}
                        buttonCancelAction={() => {
                            window.location.href = PUBLICA_URL;
                        }}
                        buttonContinueAction={this.onContinueAction}
                        buttonFinalizeText={formatText('button-continue')}
                    />
                </div>
            </div>
        );
    }
}

export default connect(
    state => ({
        pdfFile: state.userProfile.hiringPdf,
    }),
    dispatch => ({
        dispatch,
        loanIne: () => loanIne(dispatch),
        showPreLoader: bindActionCreators(showPreLoader, dispatch),
    })
)(IneLoan);
